<template>
    <div class="card" id="Device" style="direction: rtl">
        <div class="card-header">
            <h3 class="card-title">مدیریت خط</h3>
            <CButton @click="DialogAddFleet=true"   color="outline-primary" style="float:left;border-bottom-left-radius: 2px;border-top-left-radius: 2px;border-top-right-radius: 2px;border-bottom-right-radius: 2px" title="افزودن کاربر" >افزودن خط</CButton>&nbsp;
        </div>
        <div class="card-body">
            <CDataTable
                    :hover="true"
                    :border="true"
                    
                    :striped="true"
                    :small="true"
                    :items="$store.state.Fleets.RequestResponse"
                    :fields="fields"
                    :fixed="true"
                    :loading="false"
                    :items-per-page="10"
                    pagination
                    :noItemsView="{ noResults: 'چیزی یافت نشد.', noItems: 'چیزی برای نمایش وجود ندارد.' }"
            >
                <template #Edit="{item}">
                    <td style="font-size: 16px">
                        <CButton   color="primary" style="border-bottom-left-radius: 2px;border-top-left-radius: 2px;border-top-right-radius: 2px;border-bottom-right-radius: 2px" @click="EditFleet(item)">ویرایش</CButton>
                    </td>
                </template>
                <template #Delete="{item}">
                    <td style="font-size: 16px">
                        <CButton v-if="$store.state.InlineLoading.Authentication_Delete"  color="danger"  >
                            <b-spinner small></b-spinner>
                            <span class="sr-only">درحال حذف...</span>
                        </CButton>
                        <CButton v-else color="danger"  @click="DeleteAccessFleet(item.FleetID)" >
                            حذف
                        </CButton>
                    </td>
                </template>
                <template #Name="{item}">
                    <td style="font-size: 16px">
                        <CBadge v-if="item.Name===null" color="warning" >نا مشخص </CBadge>
                        <CBadge v-else-if="item.Name.length<6" color="warning">نا مشخص</CBadge>
                        <CBadge v-else  v-text="item.Name"> warning color badge</CBadge>
                    </td>
                </template>
                <template #FamilyName="{item}">
                    <td style="font-size: 16px">
                        <CBadge v-if="item.NaFamilyNameme===null" color="warning" > نا مشخص</CBadge>
                        <CBadge v-else-if="item.FamilyName.length<6" color="warning">نا مشخص</CBadge>
                        <CBadge v-else color="info" v-text="item.FamilyName"> warning color badge</CBadge>
                    </td>
                </template>
                <template #Mobile1="{item}">
                    <td style="font-size: 16px">
                        <CBadge v-if="item.Mobile1===null" color="warning" > شماره موجود نیست</CBadge>
                        <CBadge v-else-if="item.Mobile1.length<6" color="warning"> شماره موجود نیست</CBadge>
                        <CBadge v-else color="info" v-text="item.Mobile1"> warning color badge</CBadge>
                    </td>
                </template>

            </CDataTable>
        </div>
        <div class="card-footer" style="display:flex;direction:ltr;gap:10px">

            <MPrint 
                v-if="$store.state.Fleets.RequestResponse.length>0"
                :data="$store.state.Fleets.RequestResponse"
                label="PDF" 
                title="خط"
                :fields="fields">
            </MPrint>
        </div>
        <CModal
                title=""
                color="info"
                :closeOnBackdrop="false"
                :size="'lg'"
                :show.sync="DialogSelectFleet"
        >
            <div style="direction: rtl;text-align: right">

                <div >
                    <select class="form-select"  size="10" v-model="indexFleet">
                        <option v-for="(fleet,index) in $store.state.Fleets" :value="index" v-text="fleet.FleetName" v-bind:key="index" ></option>
                    </select>
                </div>
            </div>
            <template #header>

                <h4 class="modal-title" style="direction: rtl"> <CIcon name="cil-sun" width="20px" height="20px"/>&nbsp;&nbsp; انتخاب خط </h4>

            </template>
            <template #footer>
                <CButton @click="DialogSelectFleet = false" color="danger">بستن</CButton>
                <CButton @click="SelectFleet()" color="primary">&nbsp;&nbsp;  انتخاب</CButton>
            </template>
        </CModal>
        <CModal
                title=""
                color="info"
                :closeOnBackdrop="false"
                :size="'lg'"
                :show.sync="DialogAddFleet"
        >
            <div style="direction: rtl;text-align: right">
                <CRow>
                    <CCol>
                            <CInput
                                label="نام خط"
                                valid-feedback=""
                                invalid-feedback="حداقل چهار  کارکتر  می باشد."
                                value="Valid value"
                                v-model="NewFleet.FleetName"
                                :is-valid="NewFleet.FleetName.length>=4"
                            />
                    </CCol>
                    <CCol>
                        <CInput
                            label="حداکثر خودرو"
                            valid-feedback=""
                            invalid-feedback=""
                            value="Valid value"
                            v-model="NewFleet.MaxVehicle"
                            :is-valid="NewFleet.MaxVehicle>0"
                        />
                    </CCol>
                    
                </CRow>
                <CRow>
                    <CCol>
                        <CInput
                            label="حداکثر کاربر"
                            valid-feedback=""
                            invalid-feedback=""
                            value="Valid value"
                            v-model="NewFleet.MaxUser"
                            :is-valid="NewFleet.MaxUser>0"
                        />
                    </CCol>
                    <CCol>
                        <CInput
                            label="حداکثر اتصال کاربر"
                            valid-feedback=""
                            invalid-feedback=""
                            value="Valid value"
                            v-model="NewFleet.MaxUserConnect"
                            :is-valid="NewFleet.MaxUserConnect>0"
                        />
                    </CCol>
                    
                    
                </CRow>
                <CRow>
                    <CCol>
                        <CInput
                        label="شماره ثابت"
                        valid-feedback=""
                        invalid-feedback="شماره معتبر وارد نمایید برای مثال:02185452114"
                        value="Valid value"
                        v-model="NewFleet.Tel1"
                        :is-valid="validatePhone(NewFleet.Tel1)"
                        />
                    </CCol>
                    <CCol>
                        <CInput
                            label="شماره ثابت دوم"
                            v-model="NewFleet.Tel2"
                            v-if="NewFleet.Tel2.length===0"
                        />
                        <CInput
                            label="شماره ثابت دوم"
                            valid-feedback=""
                            invalid-feedback="شماره معتبر وارد نمایید برای مثال:02185452114"
                            value="Valid value"
                            v-model="NewFleet.Tel2"
                            :is-valid="validatePhone(NewFleet.Tel2)"
                            v-else
                        />
                    </CCol>
                    
                    
                </CRow>
                <CRow>
                    <CCol>
                        <CInput
                            label="شماره همراه"
                            valid-feedback=""
                            invalid-feedback="شماره معتبر وارد نمایید برای مثال:09107608438"
                            value="Valid value"
                            v-model="NewFleet.Mobile"
                            :is-valid="validatePhone(NewFleet.Mobile)"
                        />
                    </CCol>
                    <CCol>
                        <CInput
                            label="شماره فکس"
                            v-model="NewFleet.Fax"
                            v-if="NewFleet.Fax.length===0"
                        />
                        <CInput
                            label="شماره فکس"
                            valid-feedback=""
                            invalid-feedback="شماره معتبر وارد نمایید برای مثال:02185452114"
                            value="Valid value"
                            v-model="NewFleet.Fax"
                            :is-valid="validatePhone(NewFleet.Fax)"
                            v-else
                        />
                    </CCol>
                    
                    
                </CRow>
               <CRow>
                   <CCol>
                        <CInput
                        label="ایمیل"
                        v-model="NewFleet.Email"
                        v-if="NewFleet.Email.length===0"
                        />
                        <CInput
                                label="ایمیل"
                                valid-feedback=""
                                invalid-feedback="ایمیل معتبر وارد نمایید."
                                value="Valid value"
                                v-model="NewFleet.Email"
                                :is-valid="validateEmail(NewFleet.Email)"
                                v-else
                        />
                    </CCol>
                    <CCol>
                        <CTextarea
                            label="توضیحات"
                            placeholder="اینجا بنویسید ..."
                            horizontal
                            rows="9"
                            v-model="NewFleet.Description"
                        />
                    </CCol>
                   
                    
               </CRow>
                
                
                
                
                





            </div>
            <template #header>

                <h4 class="modal-title" style="direction: rtl"> <CIcon name="cil-sun" width="20px" height="20px"/>&nbsp;&nbsp;افزودن خط</h4>

            </template>
            <template #footer>
                <CButton @click="DialogAddFleet = false" color="warning">انصراف</CButton>
                <CButton color="primary" @click="AddFleet">&nbsp;&nbsp;  افزودن خط</CButton>
            </template>
        </CModal>
        <CModal
                title=""
                color="info"
                :closeOnBackdrop="false"
                :size="'lg'"
                :show.sync="DialogEditFleet"
        >
            <div style="direction: rtl;text-align: right">
                <CRow>
                    <CCol>
                        <CInput
                            label="نام خط"
                            valid-feedback=""
                            invalid-feedback="حداقل چهار  کارکتر  می باشد."
                            value="Valid value"
                            v-model="Fleet.FleetName"
                            :is-valid="Fleet.FleetName.length>=4"
                        />
                    </CCol>
                    <CCol>
                        <CInput
                            label="حداکثر خودرو"
                            valid-feedback=""
                            invalid-feedback=""
                            value="Valid value"
                            v-model="Fleet.MaxVehicle"
                            :is-valid="Fleet.MaxVehicle>0"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol>
                        <CInput
                            label="حداکثر کاربر"
                            valid-feedback=""
                            invalid-feedback=""
                            value="Valid value"
                            v-model="Fleet.MaxUser"
                            :is-valid="Fleet.MaxUser>0"
                        />
                    </CCol>
                    <CCol>
                        <CInput
                            label="حداکثر اتصال کاربر"
                            valid-feedback=""
                            invalid-feedback=""
                            value="Valid value"
                            v-model="Fleet.MaxUserConnect"
                            :is-valid="Fleet.MaxUserConnect>0"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol>
                        <CInput
                            label="شماره ثابت"
                            valid-feedback=""
                            invalid-feedback="شماره معتبر وارد نمایید برای مثال:02185452114"
                            value="Valid value"
                            v-model="Fleet.Tel1"
                            :is-valid="validatePhone(Fleet.Tel1)"
                        />
                    </CCol>
                    <CCol>
                        <CInput
                            label="حداکثر اتصال کاربر"
                            valid-feedback=""
                            invalid-feedback=""
                            value="Valid value"
                            v-model="Fleet.MaxUserConnect"
                            :is-valid="Fleet.MaxUserConnect>0"
                        />
                    </CCol>
                </CRow>
                    
                <CRow>
                    <CCol>
                        <CInput
                        label="شماره ثابت دوم"
                        v-model="Fleet.Tel2"
                        v-if="Fleet.Tel2.length===0"
                    />
                    <CInput
                            label="شماره ثابت دوم"
                            valid-feedback=""
                            invalid-feedback="شماره معتبر وارد نمایید برای مثال:02185452114"
                            value="Valid value"
                            v-model="Fleet.Tel2"
                            :is-valid="validatePhone(NewFleet.Tel2)"
                            v-else
                    />
                    </CCol>
                    <CCol>
                        <CInput
                            label="شماره همراه"
                            valid-feedback=""
                            invalid-feedback="شماره معتبر وارد نمایید برای مثال:09107608438"
                            value="Valid value"
                            v-model="Fleet.Mobile"
                            :is-valid="validatePhone(Fleet.Mobile)"
                        />
                    </CCol>
                </CRow>
               
                <CRow>
                    <CCol>
                            <CInput
                        label="شماره فکس"
                        v-model="Fleet.Fax"
                        v-if="Fleet.Fax.length===0"
                        />
                        <CInput
                                label="شماره فکس"
                                valid-feedback=""
                                invalid-feedback="شماره معتبر وارد نمایید برای مثال:02185452114"
                                value="Valid value"
                                v-model="Fleet.Fax"
                                :is-valid="validatePhone(Fleet.Fax)"
                                v-else
                        />
                    </CCol>
                    <CCol>
                        <CInput
                            label="ایمیل"
                            v-model="Fleet.Email"
                            v-if="Fleet.Email.length===0"
                        />
                        <CInput
                            label="ایمیل"
                            valid-feedback=""
                            invalid-feedback="ایمیل معتبر وارد نمایید."
                            value="Valid value"
                            v-model="Fleet.Email"
                            :is-valid="validateEmail(Fleet.Email)"
                            v-else
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol>
                        <CTextarea
                            label="توضیحات"
                            placeholder="اینجا بنویسید ..."
                            horizontal
                         
                            v-model="Fleet.Description"
                        />
                    </CCol>
 
                </CRow>
                
                
                





            </div>
            <template #header>

                <h4 class="modal-title" style="direction: rtl"> <CIcon name="cil-sun" width="20px" height="20px"/>&nbsp;&nbsp;افزودن خط</h4>

            </template>
            <template #footer>
                <CButton @click="DialogEditFleet = false" color="warning">انصراف</CButton>
                <CButton color="primary" @click="UpdateFleet()">&nbsp;&nbsp;  ذخیره تغییرات</CButton>
            </template>
        </CModal>
    </div>
</template>

<script>
    import Vue from 'vue'
    import Constant from './../../assets/Constants'
    export default {
        name: "Drivers",
        data(){
            return {
                
                User:null,
                Fleets: [],
                Drivers: [],
                indexFleet:0,
                Fleet:{FleetName:"",
                    MaxVehicle:20,
                    MaxUser:20,
                    MaxUserConnect:20,
                    Tel1:'',
                    Tel2:'',
                    Mobile:'',
                    Fax:'',
                    Email:'',
                    Description:''},
                NewFleet:{
                    FleetName:"",
                    MaxVehicle:20,
                    MaxUser:20,
                    MaxUserConnect:20,
                    Tel1:'',
                    Tel2:'',
                    Mobile:'',
                    Fax:'',
                    Email:'',
                    Description:'',
                },
                DialogSelectFleet:false,
                DialogAddFleet:false,
                DialogEditFleet:false,
                TextSearchFleet:'',
                fields:[{"key":"FleetID","label":"شناسه خط"},{"key":"FleetName","label":"نام خط"},{"key":"MaxVehicle","label":"حدااکثر خودرو"},{"key":"MaxUser","label":"حداکثر کاربر"},{"key":"Edit","label":"ویرایش"},{"key":"Delete","label":"حذف"}],
            }
        },
        computed:{
            ReadAddFleet(){
                return this.$store.state.ResponseFleet_Add;
            },
            ReadEditFleet(){
                return this.$store.state.ResponseFleet_Update;
            },
            ReadDeleteFleet(){
                return this.$store.state.ResponseAuthentication_Delete;
            },
           
        },
        watch:{
            ReadAddFleet(res){
                if(res.Status){
                    if(res.RequestResponse[0].Message==='Successfully!'){
                        this.DialogAddFleet=false;
                        this.GetFleets();
                        this.$store.commit('ShowToast',{type:'success',message:'عملیات با موفقیت انجام شد.'})
                    }
                    
                }
            },
            ReadEditFleet(res){
                if(res.Status){
                    if(res.RequestResponse[0].Message==='Successfully!'){
                        this.DialogEditFleet=false;
                        this.GetFleets();
                        this.$store.commit('ShowToast',{type:'success',message:'عملیات با موفقیت انجام شد.'})
                    }
                    
                }
            },
            ReadDeleteFleet(res){
                if(res.Status){
                    if(res.RequestResponse[0].Message==='Successfully!'){
                        this.GetFleets();
                        this.$store.commit('ShowToast',{type:'success',message:'عملیات با موفقیت انجام شد.'})
                    }
                    
                }
            },
        },
        mounted() {
            this.User= this.$session.get("User");
            this.GetFleets();
        },
        methods:{
            GetFleets(){
                this.$store.commit('FleetByUser');
            },
            SelectFleet()
            {
                this.Fleet=this.Fleets[this.indexFleet];
                this.DialogSelectFleet=false;
                this.DialogSelectFleet=false;
            },
            validateEmail(email) {
                const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(String(email).toLowerCase());
            },
            validatePhone(phone) {
                const re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
                return re.test(String(phone).toLowerCase());
            },
            EditFleet(item){
                this.Fleet=item;
                this.DialogEditFleet=true;
            },
            UpdateFleet(){
                this.$store.commit('Fleet_Update',{
                    UserID:1,
                    FleetID:this.Fleet.FleetID,
                    FleetName:this.Fleet.FleetName,
                    MaxVehicle:this.Fleet.MaxVehicle,
                    MaxUser:this.Fleet.MaxUser,
                    MaxUserConnect:this.Fleet.MaxUserConnect,
                    Tel1:this.Fleet.Tel1,
                    Tel2:this.Fleet.Tel2,
                    Mobile:this.Fleet.Mobile,
                    Fax:this.Fleet.Fax,
                    Email:this.Fleet.Email,
                    Description:this.Fleet.Description,
                });
                
            },
            DeleteAccessFleet(FleetID){
                this.$store.commit('Authentication_Delete',{
                    UserID:2188,
                    FleetID:FleetID,
                });
                
            },
            AddFleet(){
                if(this.NewFleet.FleetName.length<4){
                    this.$store.commit('ShowToast',{type:'error',message:'نام خط معتبر را وارد نمایید.'});
                }
                else {
                    if(this.NewFleet.MaxVehicle===''){
                        this.NewFleet.MaxVehicle=1;
                    }
                    if(this.NewFleet.MaxUser===''){
                        this.NewFleet.MaxUser=1;
                    }
                    if(this.NewFleet.MaxUserConnect===''){
                        this.NewFleet.MaxUserConnect=1;
                    }
                    if(this.NewFleet.MaxUser===''){
                        this.NewFleet.MaxUser=1;
                    }
                    if(this.NewFleet.Tel1===''){
                        this.NewFleet.Tel1="0";
                    }
                    if(this.NewFleet.Tel2===''){
                        this.NewFleet.Tel2="0";
                    }
                    if(this.NewFleet.Mobile===''){
                        this.NewFleet.Mobile="0";
                    }
                    if(this.NewFleet.Fax===''){
                        this.NewFleet.Fax="0";
                    }
                    if(this.NewFleet.Email===''){
                        this.NewFleet.Email="0";
                    }


                    if(this.NewFleet.Description===''){
                        this.NewFleet.Description="No Description";
                    }
                this.$store.commit('Fleet_Add',{
                    UserID:2188,
                    FleetName:this.NewFleet.FleetName,
                    MaxVehicle:this.NewFleet.MaxVehicle,
                    MaxUser:this.NewFleet.MaxUser,
                    MaxUserConnect:this.NewFleet.MaxUserConnect,
                    Tel1:this.NewFleet.Tel1,
                    Tel2:this.NewFleet.Tel2,
                    Mobile:this.NewFleet.Mobile,
                    Fax:this.NewFleet.Fax,
                    Email:this.NewFleet.Email,
                    Description:this.NewFleet.Description,
                });
                  
                }

            }

        }
    }
</script>

<style scoped>

</style>